import { useRef } from "react";
import { ConfirmPanel } from "@/components/ui/ConfirmPanel";
import { useIdleLogout } from "@/hooks/useIdleLogout";
import "./account.css";

/**
 * IdleWarning — E-5 PC 유휴 경고(12 설계 §7-2 · 04 세션 정책 §3-2).
 * 확인창 공용 틀(ConfirmPanel, kind warning — 제목 주황)에 남은 시간 상자를 넣었다. 주 버튼 = [계속 사용].
 * Esc·배경 클릭도 "계속 사용"으로 본다(사람이 앞에 있다는 뜻).
 *
 * 1초마다 남은 시간이 바뀌므로 Layout 전체가 다시 그려지지 않게 이 컴포넌트 안에서만 훅을 돈다(IdleWatcher).
 */
export function IdleWatcher() {
  const { warning, remainingMs, keepUsing, logoutNow } = useIdleLogout();
  if (!warning) return null;
  return <IdleWarning remainingMs={remainingMs} onKeep={keepUsing} onLogout={logoutNow} />;
}

function mmss(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
}

export function IdleWarning({ remainingMs, onKeep, onLogout }: { remainingMs: number; onKeep: () => void; onLogout: () => void }) {
  const keepRef = useRef<HTMLButtonElement>(null);
  return (
    <ConfirmPanel
      kind="warning"
      title="계속 사용할까요?"
      summary="4시간 동안 사용 기록이 없어 5분 뒤 자동 로그아웃됩니다."
      onDismiss={onKeep}
      initialFocus={keepRef}
      className="ma-idle"
      actions={
        <>
          <button type="button" className="btn-ghost" onClick={onLogout}>
            지금 로그아웃
          </button>
          <button ref={keepRef} type="button" className="btn-primary confirm-btn-warning" onClick={onKeep}>
            계속 사용
          </button>
        </>
      }
    >
      <div className="ma-idle-box" aria-live="polite">
        <div className="ma-idle-time">
          남은 시간 <span className="mono">{mmss(remainingMs)}</span>
        </div>
        <ul className="ma-idle-list">
          <li>계속 사용하면 4시간이 다시 시작됩니다</li>
          <li>시간이 지나면 저장하지 않은 입력은 사라집니다</li>
        </ul>
      </div>
    </ConfirmPanel>
  );
}
